import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'gf-inline-confirm',
  template: require('./gf-inline-confirm.component.html')
})
export class GfInlineConfirmComponent {
  @Input() message: string = 'Are you sure?';
  @Input() confirmLabel: string = 'Delete';
  @Input() cancelLabel: string = 'Cancel';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
